import DashboardCharts from './components/DashboardCharts'
import DashboardStatisticCards from './components/DashboardStatisticCards'
import BaseConfig from 'general/constants/DomainConfig'
import { useHostname } from 'general/context/HostnameContext'
import { DashboardFooter } from './components/DashboardFooter'

function DashboardHomeScreen() {
  const hostname = useHostname()
  return (
    <div className="container-fluid px-5 pb-5">
      <div className="card card-custom py-5 relative">
        {/* card stat */}
        <DashboardStatisticCards />
        {/* Charts */}
        <DashboardCharts />
        {BaseConfig[hostname]?.footer?.isHadFooter && (
          <DashboardFooter content={BaseConfig[hostname]?.footer?.content} />
        )}
      </div>
    </div>
  )
}

export default DashboardHomeScreen
